import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { KioskType } from '../../@types';
import { useGetShareUrl } from '../../hooks/useGetShareUrl';
import { useKioskManager } from '../../hooks/useKioskManager';
import { useNetworkManager } from '../../hooks/useNetworkManager';
import ButtonStyled from '../shared/button/Button';
import { Modal } from '../shared/modal/Modal';
import QRCode from '../shared/qrCode/QRCode';
import styles from './shareDirectionsToMobileModal.module.scss';

type ShareDirectionsToMobileModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ShareDirectionsToMobileModal: React.FC<
  ShareDirectionsToMobileModalProps
> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('common');
  const { siteLogo, siteName } = useNetworkManager();
  const { kiosk, kioskMode } = useKioskManager();

  const navUrl = useGetShareUrl();

  const logoSize = useMemo(
    () =>
      kiosk && kioskMode && kiosk.model === KioskType.BA_TABLET ? 366 : 169,
    [kiosk, kioskMode],
  );

  return (
    <Modal isOpen={isOpen}>
      <div
        className={`${
          kioskMode && kiosk?.model === KioskType.ELO_TOUCH
            ? styles[kiosk.model]
            : styles.container
        }`}
      >
        <h2 className={styles.title}>
          {t('campusNavigation.share.phone.title')}
        </h2>
        <p className={styles.description}>
          {t('campusNavigation.share.phone.description')}
        </p>
        <div className={styles.contentContainer}>
          <div className={styles.qrContainer}>
            <QRCode url={navUrl} />
            <img src={siteLogo} alt={siteName} width={logoSize} />
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <ButtonStyled
            onClick={onClose}
            className={styles.button}
            uppercase
            ariaLabel="Close"
          >
            {t('labels.close')}
          </ButtonStyled>
        </div>
      </div>
    </Modal>
  );
};

export default ShareDirectionsToMobileModal;
